import { v1ApiClient } from '@/services';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import type { SlackAskBotInfoT } from './types';

const slackAskBotService = {
  fetchSlackAskBotInfoList: async (): Promise<SlackAskBotInfoT[]> => {
    const wa = getCurrWorkspaceAlias();
    const res = await v1ApiClient.get(`/workspaces/${wa}/slackaskbot`);
    return res.data;
  },
  createSlackAskBotInfo: async (code: string, workspaceAlias: string) => {
    try {
      await v1ApiClient.post(`/workspaces/${workspaceAlias}/slackaskbot`, {
        code,
      });
      return true;
    } catch (e) {
      return false;
    }
  },
  deleteSlackAskBotInfo: async (alias: string) => {
    const wa = getCurrWorkspaceAlias();
    await v1ApiClient.delete(`workspaces/${wa}/slackaskbot/${alias}`);
  },
  changeSlackAskBotStatus: async (alias: string) => {
    const wa = getCurrWorkspaceAlias();
    await v1ApiClient.patch(`/slackaskbot/${alias}`, {
      workspace_id: wa,
    });
  },
};

export default slackAskBotService;
